<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M21.531 7.28063L9.53104 19.2806C9.46139 19.3504 9.37867 19.4057 9.28762 19.4434C9.19657 19.4812 9.09898 19.5006 9.00042 19.5006C8.90185 19.5006 8.80426 19.4812 8.71321 19.4434C8.62216 19.4057 8.53945 19.3504 8.46979 19.2806L3.21979 14.0306C3.07906 13.8899 3 13.699 3 13.5C3 13.301 3.07906 13.1101 3.21979 12.9694C3.36052 12.8286 3.55139 12.7496 3.75042 12.7496C3.94944 12.7496 4.14031 12.8286 4.28104 12.9694L9.00042 17.6897L20.4698 6.21938C20.6105 6.07865 20.8014 5.99959 21.0004 5.99959C21.1994 5.99959 21.3903 6.07865 21.531 6.21938C21.6718 6.36011 21.7508 6.55098 21.7508 6.75001C21.7508 6.94903 21.6718 7.1399 21.531 7.28063Z"
      :fill="fill"
      :stroke="fill"
    />
  </svg>
</template>

<script setup>
defineOptions({
  name: 'V2IconsCheck'
})

defineProps({
  fill: {
    type: String,
    default: '#671CC2'
  }
})
</script>
